module.exports = __webpack_public_path__ + "static/media/quince.67da0e3f.png";